<template>
    <div class="forum-home-latest">
        <ForumThreadList
            ref="threadList"
            class="thread-list"
            :sortable="true"
            :sort-order="sortOrder"
            :threads="threads"
            @update:sort-order="$emit('update:sort-order', $event)"
        />

        <Loader
            v-if="canLoadMoreThreads"
            v-show="loadingThreads"
        />

        <div
            class="after-threads-msg"
            v-if="!canLoadMoreThreads">
            That's all, folks!
        </div>
    </div>
</template>

<script>
    import ForumUtils      from '../../utils/forum';
    import ForumThreadList from '../reusable/forum/thread-list';
    import Loader          from '../reusable/forum/loader';

    function getViewportBottom() {
        const $window = $(window);
        return $window.scrollTop() + $window.height();
    }

    function getBottomPos(elem) {
        const $elem = $(elem);
        return $elem.offset().top + $elem.outerHeight();
    }

    export default {
        props: {
            sortOrder: {
                type: String,
                default: 'default',
            },
        },

        components: {
            ForumThreadList,
            Loader,
        },

        data() {
            return {
                threadList: new ForumUtils.PaginatedThreadList(),
            };
        },

        async mounted() {
            window.addEventListener('scroll', this.autoLoadThreads);
            window.addEventListener('resize', this.autoLoadThreads);

            // Reload the thread list rather than auto loading since the
            // original thread list is created without parameters.
            await this.reloadThreadList();
        },

        beforeDestroy() {
            window.removeEventListener('scroll', this.autoLoadThreads);
            window.removeEventListener('resize', this.autoLoadThreads);
        },

        methods: {
            isThreadListBottomNearView() {
                const offset = 200;
                const viewBottom = getViewportBottom();
                const listBottom = getBottomPos(this.$refs.threadList.$el);
                return listBottom <= viewBottom + offset;
            },

            shouldLoadMoreThreads() {
                if (!this.canLoadMoreThreads) {
                    // There is nothing else to load.
                    return false;

                } else if (this.loadingThreads) {
                    // We are already loading the next batch.
                    return false;

                } else if (this.threads.length === 0) {
                    // If the thread list was just reloaded, the bottom may
                    // still be out of view due to the old rendered threads; in
                    // this case, we want to fetch the new ones.
                    return true;
                }
                return this.isThreadListBottomNearView();
            },

            async autoLoadThreads() {
                while (this.shouldLoadMoreThreads()) {
                    await this.threadList.loadMore();
                }
            },

            async reloadThreadList() {
                const p = this.searchParams;
                this.threadList = new ForumUtils.PaginatedThreadList(p);
                await this.autoLoadThreads();
            },
        },

        computed: {
            searchParams() {
                let order = this.sortOrder;
                if (order === 'default') {
                    order = 'lastPostCreatedAt:desc';
                }
                return { order };
            },

            threads() {
                return this.threadList.threads;
            },

            canLoadMoreThreads() {
                return this.threadList.hasMore();
            },

            loadingThreads() {
                return this.threadList.isLoading();
            },
        },

        watch: {
            searchParams: function() {
                this.reloadThreadList();
            },
        },
    }
</script>

<style lang="scss" scoped>
    .thread-list {
        margin-top: 20px;
    }

    .after-threads-msg {
        font-weight: bold;
        margin-top: 30px;
    }
</style>



// WEBPACK FOOTER //
// ForumHomeLatest.vue?1d3ee90a